module.exports = () => {

    const apiKey = process.env.PLACES_KEY;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${apiKey}`;
    document.querySelector('head').appendChild(script);
};
